import React, { CSSProperties } from 'react';
import { useTheme } from 'styled-components';

import { Paragraph } from 'common/components';

import { Button, Label } from './Chips.styled';

interface IChips {
  onClick?: () => void;
  label: string | number;
  rightIcon?: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIconStateFill?: string;
  margin?: string;
  padding?: string;
  labelPadding?: string;
  borderColor?: string;
  borderRadius?: string;
  backgroundColor?: string;
  defaultLabelText?: boolean;
  disableClick?: boolean;
  color?: string;
  dataFor?: string;
  dataTip?: string;
  fontSize?: string;
  fontFamilyOutside?: string;
  additionalBtnStyle?: CSSProperties;
  additionalParagraphStyle?: CSSProperties;
}

export const Chips = ({
  onClick,
  label,
  rightIcon,
  leftIcon,
  rightIconStateFill,
  margin,
  padding,
  labelPadding,
  borderColor,
  borderRadius,
  backgroundColor,
  defaultLabelText,
  disableClick,
  color,
  dataFor,
  dataTip,
  fontSize,
  fontFamilyOutside,
  additionalBtnStyle,
  additionalParagraphStyle,
}: IChips) => {
  const { fontFamily } = useTheme();

  return (
    <Button
      data-for={dataFor}
      data-tip={dataTip}
      onClick={onClick}
      type="button"
      rightIconStateFill={rightIconStateFill}
      margin={margin}
      padding={padding}
      borderColor={borderColor}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      disableClick={disableClick}
      additionalBtnStyle={additionalBtnStyle}
    >
      {defaultLabelText ? (
        <Paragraph
          color={color}
          fontFamily={fontFamilyOutside || fontFamily.regular}
          fontSize={fontSize || '0.875rem'}
          fontWeight="500"
          lineHeight="1.5rem"
          margin="0"
          padding={labelPadding || '0 0.5rem'}
          style={additionalParagraphStyle}
        >
          {leftIcon}
          {label}
          {rightIcon}
        </Paragraph>
      ) : (
        <Label fontSize={fontSize} labelPadding={labelPadding}>
          {leftIcon} {label} {rightIcon}
        </Label>
      )}
    </Button>
  );
};
